<script setup lang="ts">
  import { computed } from 'vue'

  import RichTextRenderer from '@/components/common/RichTextRenderer.vue'

  type SubtaskVariant = 'number' | 'alpha'
  const props = withDefaults(defineProps<{
    subtasks: string[]
    variant?: SubtaskVariant
  }>(), {
    variant: 'alpha'
  })

  const alphaLabel = ['a', 'b', 'c', 'd']
  const numberLabel = ['1', '2', '3', '4']

  const bulletLabel = computed(() => {
    switch (props.variant) {
    case 'number':
      return numberLabel
    case 'alpha':
    default:
      return alphaLabel
    }
  })

  const isEmpty = computed(() => !props.subtasks.some(subtask => !!subtask))
</script>

<template>
  <ol
    v-if="subtasks.length && !isEmpty"
    type="a"
    class="subtasks"
  >
    <template
      v-for="(subtask, index) in subtasks"
      :key="index"
    >
      <li v-if="subtask">
        <label class="label">
          {{ bulletLabel[index] }}
        </label>
        <div class="subtask">
          <RichTextRenderer :rich-text="subtask" />
        </div>
      </li>
    </template>
  </ol>
</template>

<style scoped lang="scss">
  .subtasks {
    font-size: 1.125rem;
    list-style: none;
    padding: 0;
    margin-bottom: 40px;

    .label {
      @include bullet-label;

      height: 40px;
      width: 40px;
      background-color: var(--color-orange-20);
      border-radius: 40px;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
    }

    li {
      counter-increment: count 1;
      display: flex;
      align-items: flex-start;
      gap: 16px;
      margin: 12px 0;

      .subtask {
        /* override margin from first p element with class name cms-p */
        :deep(.cms-p:first-of-type) {
          margin-top: 5px;
        }
      }
    }
  }
</style>